import "./privacyBanner.css";
import { useEffect, useState } from "react";
import { STORAGE_KEY } from "../../utils/GlobalConstants";

export default function PrivacyBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const closeBanner = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="privacy-banner">
      <span>
        Droppie uses cookies and analytics to enhance your experience. By
        continuing, you consent to their use.
      </span>

      <button onClick={closeBanner} aria-label="Close banner">
        ✕
      </button>
    </div>
  );
}
